import jsPDF from "jspdf";
import {
  store
} from "../../index";
import moment from "moment";
import {
  imgData
} from "./letterhead";
import Roundy from "../../services/roundy";
import {
  estformatnumber
} from "../../services/tnminvnumbers";
const pdfdownload = estimate => {
  var sheetcount = 1;
  if (estimate.tasks && estimate.tasks.length) {
    sheetcount += 1;
  }
  console.log("printing estimate", estimate);
  var index = 0;
  var sheetNum = 1;
  var employees = store.getState().employees.employees;
  // You'll need to make your image into a Data URL
  // Use http://dataurl.net/#dataurlmaker
  var items;
  if (estimate.tasks) {
    items = estimate.tasks.length;
    if (estimate.deliverables) {
      items += estimate.deliverables.length;
    }
  }

  var multipage = items >= 15;
  if (multipage) {
    sheetcount += 1;
  }
  var doc = new jsPDF();
  //Header Image
  doc.addImage(imgData, "JPEG", 15, 10, 113, 22);

  doc.setFontSize(18);
  doc.setFont("helvetica");
  doc.setFontType("bold");
  doc.text(160, 20, "Estimate");

  //HR
  doc.setLineWidth(0.5);
  doc.line(15, 37, 200, 37);

  //Header
  doc.setFontSize(12);
  doc.setFont("helvetica");
  doc.setFontType("bold");
  doc.text(15, 47, "Estimate For:");
  doc.setFontType("normal");
  doc.text(15, 52, estimate.billing.companyname1);
  doc.text(15, 57, estimate.billing.street1);
  doc.text(15, 62, estimate.billing.city + " " + estimate.billing.state);
  doc.text(15, 67, "ATTN: " + estimate.projmanager);
  doc.setFontType("bold");
  doc.text(15, 75, "REMIT TO:");
  doc.setFontType("normal");
  doc.text(15, 80, "8390 Currency Dr.");
  doc.text(15, 85, "Riviera Beach Fl. 33404 Unit 4");
  doc.text(15, 90, "Phone: 561-844-8886");
  doc.text(15, 95, "Fax: 561-842-3929");
  doc.setFontType("bold");
  doc.text(141, 52, "Number:");
  doc.setFontType("normal");
  doc.text(160, 52, estformatnumber(estimate));
  doc.setFontType("bold");
  doc.text(148, 57, "Date:");
  doc.setFontType("normal");
  doc.text(160, 57, moment(estimate.createdate).format("MM/DD/YYYY"));

  doc.setFontType("bold");

  doc.text(125, 62, "Purchase Order:");

  doc.setFontType("normal");
  doc.text(160, 62, estimate.poNumber ? estimate.poNumber.toString() : "");

  doc.setFontType("bold");
  doc.text(136, 67, "Line Item#:");
  doc.setFontType("normal");
  doc.text(
    160,
    67,
    estimate.poItemNumber ? estimate.poItemNumber.toString() : ""
  );

  doc.setFontType("bold");
  doc.text(145, 72, "SOW#:");
  doc.setFontType("normal");
  doc.text(160, 72, estimate.sowNumber ? estimate.sowNumber.toString() : "");

  doc.setFontType("bold");
  doc.text(146, 77, "EDF#:");
  doc.setFontType("normal");
  doc.text(160, 77, estimate.workOrderNbr ? estimate.workOrderNbr : "");

  var descLine = 105;
  if (estimate.description) {
    doc.setFontType("bold");
    doc.text(15, descLine, "Description:");
    descLine += 7;
    doc.setFontType("normal");
    var splitdesc = doc.splitTextToSize(estimate.description, 160);
    doc.text(15, descLine, estimate.description);
    splitdesc.map((d, d_index) => {
      if (d_index) {
        descLine += 7;
      }
    });
    descLine += 10;
  }
  if (estimate.scopeOfWorkSummary) {
    var splitscope = doc.splitTextToSize(estimate.scopeOfWorkSummary, 160);
    doc.setFontType("bold");
    doc.text(15, descLine, "Scope of Work:");
    doc.setFontType("normal");
    descLine += 6
    doc.text(15, descLine, splitscope);
    let returns = estimate.scopeOfWorkSummary.match(/[^\n]*\n[^\n]*/gi)
    let return_count = returns? returns.length + 1 : 2
    let lines = return_count > splitscope.length? return_count: splitscope.length
    console.log("Return count", return_count, "split count", splitscope.length, "DescLine", descLine)
    descLine += (return_count*8)
    descLine += 10
    console.log("DescLine", descLine)
  }
  //Time Entrys
  //+6 pt in Y directopm per entry
  doc.setFontType("normal");
  var lastrow;
  //Time Example
  var row = descLine;
  doc.setFontType("normal");

  // doc.text(171, 285, "Authorized");
  // doc.text(171, 293, "Representative");
  if (estimate.tasks || estimate.deliverables) {
    doc.setFontType("normal");
    // doc.text(107, 285, "Authorized Representative Initial:");
    // doc.line(171, 285, 190, 285);
    // var next_sheet_string = estimate.deliverables ?
    //   "Tasks And Deliverables on next sheet." :
    //   "Tasks on next sheet.";
    // doc.text(15, 285, next_sheet_string);
    // doc.addPage();
    // row = 45;
  } else {
    doc.text(110, 285, "Approved:");
    doc.line(131, 285, 200, 285);
    doc.text(142, 290, "Authorized Representative");
  }
  if (estimate.tasks && estimate.tasks.length) {
    doc.setFontType("normal");

    var subtitle_row = row - 9;
    var title_row = subtitle_row - 9;
    doc.setFontType("bold");
    doc.text(15, title_row, "Tasks");
    doc.text(15, subtitle_row, "Task #");
    doc.text(40, subtitle_row, "Task Description");
    doc.text(125, subtitle_row, "Hours");
    doc.text(152, subtitle_row, "Rate");
    doc.text(177, subtitle_row, "Subtotal");
    var task_hours = 0;
    var task_subtotal = 0;
    var desc_overflow_length = 0;
    estimate.tasks.map((task, index) => {
      if (index) {
        if (row >= 250) {
          doc.setFontType("normal");
          doc.text(15, 285, "Continued on next sheet");
          doc.setFontType("normal");
          doc.text(107, 285, "Authorized Representative Initial:");
          doc.line(171, 285, 190, 285);
          doc.text(100, 293, "Sheet " + sheetNum +"");
          doc.addPage();
          sheetNum += 1
          row = 45;

          doc.setFontType("normal");
          
        } else {
          row += 7;
        }
      }
      task_hours += parseFloat(task.hours);
      task_subtotal += parseFloat(task.subtotal);
      //+6 pt in Y directopm per entry
      doc.setFontType("normal");
      var splitdesc = doc.splitTextToSize(task.description, 85);

      doc.text(15, row, task.item.toString());
      doc.text(37, row, splitdesc);
      doc.text(125, row, task.hours.toString());
      doc.text(152, row, "$" + task.rateinfo.payrate);
      doc.text(177, row, "$" + task.subtotal);
      splitdesc.map((s, desc_index) => {
        if (desc_index) {
          row += 5;
        }
      });
    });
    row += 10;
    doc.text(125, row, Roundy(task_hours).toString());
    doc.text(152, row, "Total");
    doc.text(177, row, "$" + Roundy(task_subtotal));
  }
  if (estimate.deliverables && estimate.deliverables.length) {
    row += 8;
    doc.setFontType("bold");
    doc.text(15, row, "Deliverables");
    row += 8;
    estimate.deliverables.map((deliv, index) => {
      if (index) {
        if (row >= 250) {
          doc.setFontType("normal");
          doc.text(107, 285, "Continued on next sheet");
          doc.setFontType("normal");
          doc.text(107, 285, "Authorized Representative Initial:");
          doc.line(171, 285, 190, 285);
          doc.setFontType("normal");
          doc.text(100, 293, "(Sheet " + sheetNum +")");

          doc.addPage();
          row = 45;

         
        } else {
          row += 7;
        }
      }

      doc.setFontType("normal");
      var deliv_splitdesc = doc.splitTextToSize(deliv.description, 160);
      // doc.text(160, row - 53, deliv.workOrderNbr);
      //Charge Example
      doc.text(15, row, deliv.item.toString());
      doc.text(37, row, deliv_splitdesc);
      deliv_splitdesc.map((s, desc_index) => {
        if (desc_index) {
          row += 5;
        }
      });
    });
  }
  if (estimate.tasks || estimate.deliverables) {
    doc.text(110, 285, "Approved:");
    doc.line(131, 285, 200, 285);

    doc.text(142, 290, "Authorized Representative");
    doc.text(100, 293, "(Sheet " + sheetNum + " of " + sheetNum + ")");
  }
  if (!estimate.tasks && !estimate.deliverables) {
    doc.setFontType("bold");
    doc.text(15, 285, "Total:");
    doc.setFontType("normal");
    doc.text(35, 285, "$" + Roundy(estimate.total));
  }
  doc.save(estformatnumber(estimate) + ".pdf");
};

export default pdfdownload;


// WEBPACK FOOTER //
// ./src/components/pdf/estimatePDFDownloadOneSheet.js